import { Menu, Modal } from '@mantine/core';
import PrimaryDropDown from 'app/views/components/DropDown/DropDown';
import { useDispatch } from 'react-redux';
import { LoanIncreaseParams } from 'app/models/loan-increase-params';
import {
  approveLoanIncrease,
  deleteLoanIncrease,
  rejectLoanIncrease,
  submitLoanIncrease,
} from './increase-daml-actions';
import { useState } from 'react';
import { useApprovedLoan } from '../loans/utilities/use-approved-loan';
import IncreaseFormLogic from './increase-form-logic';
import IonIcon from '@reacticons/ionicons';
import { LoanParams } from 'app/models/loan-params';
import DeleteConfirmation from 'app/views/components/delete-confirmation/DeleteConfirmation';
import { CenteredLoader } from 'app/views/components/loader/loader';

type Props = {
  row: LoanIncreaseParams;
};

export default function LoanIncreaseActions({ row }: Props) {
  const resolveLoan = useApprovedLoan();
  const [openNewIncrease, setOpenNewIncrease] = useState(false);
  const [loan, setLoan] = useState<LoanParams>();
  const [showDeleteModal, setShowDeleteModal] = useState(false); // State for delete modal
  const dispatch = useDispatch();

  // Edit needs the increase's loan: from the approved-loans slice when the page
  // has it, otherwise fetched by id (the Servicing page loads no loans up front).
  async function openIncrease() {
    setLoan(undefined);
    setOpenNewIncrease(true);
    const resolved = await resolveLoan(row.loanId.id);
    if (!resolved) {
      setOpenNewIncrease(false);
      return;
    }
    setLoan(resolved);
  }

  const handleDelete = async () => {
    await deleteLoanIncrease(row, dispatch); // Perform delete action
    setShowDeleteModal(false); // Close modal
  };

  return (
    <div>
      <Modal
        size="50%"
        className="modal-body modal-body-template fit-content-modal form-no-stepper"
        opened={openNewIncrease}
        onClose={() => setOpenNewIncrease(false)}
      >
        {loan ? <IncreaseFormLogic loan={loan} close={() => setOpenNewIncrease(false)} /> : <CenteredLoader />}
      </Modal>

      <Menu shadow="md" width={200} position="bottom" withinPortal>
        <Menu.Target>
          <div style={{ width: 'fit-content' }}>
            <PrimaryDropDown>Actions</PrimaryDropDown>
          </div>
        </Menu.Target>

        <Menu.Dropdown>
          {row?.status?.toLowerCase() === 'draft' ? (
            <Menu.Item
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => openIncrease()}
            >
              Edit
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() === 'draft' ? (
            <Menu.Item
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => {
                submitLoanIncrease(row, dispatch);
              }}
            >
              Submit For Approval
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() === 'submitted' ? (
            <Menu.Item
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => {
                approveLoanIncrease(row, dispatch);
              }}
            >
              Approve
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() === 'approved' ? (
            <Menu.Item icon={<IonIcon className="action-ion-icon" name="open-outline" />}>
              Amendment
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() !== 'approved' ? (
            <>
              <Menu.Divider />
              <Menu.Label>Danger zone</Menu.Label>
            </>
          ) : null}

          {row?.status?.toLowerCase() === 'draft' ? (
            <Menu.Item
              color="red"
              icon={<IonIcon className="action-ion-icon" name="trash-outline" />}
              onClick={() => setShowDeleteModal(true)} // Show delete confirmation modal
            >
              Delete
            </Menu.Item>
          ) : null}

          {row?.status?.toLowerCase() === 'submitted' ? (
            <Menu.Item
              color="red"
              icon={<IonIcon className="action-ion-icon" name="swap-horizontal-outline" />}
              onClick={() => {
                rejectLoanIncrease(row, dispatch);
              }}
            >
              Reject
            </Menu.Item>
          ) : null}
        </Menu.Dropdown>
      </Menu>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <DeleteConfirmation
          onConfirm={handleDelete} // Handle delete action
          onCancel={() => setShowDeleteModal(false)} // Close modal on cancel
          message="Delete This Loan Increase?" // Custom message
        />
      )}
    </div>
  );
}
